import React from "react";

function ViewCompanyDetails({ companyData, isOpen, onClose }) {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Overlay */}
      <div
        onClick={onClose}
        className="absolute inset-0 bg-black/40 backdrop-blur-sm transition-opacity"
      />

      {/* Modal Card */}
      <div className="relative bg-white w-[95%] max-w-2xl rounded-2xl shadow-2xl p-8 animate-[fadeIn_.25s_ease-out]">
        {/* Header */}
        <div className="flex justify-between items-center border-b pb-4 mb-6">
          <h2 className="text-2xl font-semibold text-gray-800">
            Company Details
          </h2>

          <button
            onClick={onClose}
            className="text-gray-400 hover:text-red-500 transition text-xl"
          >
            ✕
          </button>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 text-sm">
          <div>
            <p className="text-gray-500">Company Name</p>
            <p className="font-medium text-gray-800">
              {companyData?.company_details?.company_name || "—"}
            </p>
          </div>

          <div>
            <p className="text-gray-500">Authorized Person</p>
            <p className="font-medium text-gray-800">
              {companyData?.company_details?.authorized_person_name || "—"}
            </p>
          </div>

          <div className="sm:col-span-2">
            <p className="text-gray-500">Company Address</p>
            <p className="font-medium text-gray-800">
              {companyData?.company_details?.company_address || "—"}
            </p>
          </div>

          <div>
            <p className="text-gray-500">CIN</p>
            <p className="font-medium text-gray-800">
              {companyData?.company_details?.company_cin || "—"}
            </p>
          </div>

          <div>
            <p className="text-gray-500">GST Number</p>
            <p className="font-medium text-gray-800">
              {companyData?.company_details?.company_gst_no || "—"}
            </p>
          </div>

          <div>
            <p className="text-gray-500">PAN</p>
            <p className="font-medium text-gray-800">
              {companyData?.company_details?.company_pan || "—"}
            </p>
          </div>

          <div>
            <p className="text-gray-500">Account Status</p>
            <p className="font-medium text-gray-800 capitalize">
              {companyData?.account_status || "—"}
            </p>
          </div>

          <div>
            <p className="text-gray-500">KYC Status</p>
            <p className="font-medium text-gray-800 capitalize">
              {companyData?.digital_kyc_status || "—"}
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-8 text-right">
          <button
            onClick={onClose}
            className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default ViewCompanyDetails;
